import React, { useEffect, useState } from "react";
import searcher from "../../assets/icons/searchInput.svg";
import back from "../../assets/icons/back.svg";
import MainLayout from "../../components/layout/mainLayout/mainLayout";
import ManufacturerVersionTable from "./manufacturer-version-table";
import { useLocation, useNavigate } from "react-router-dom";

const ManufacturerVersionList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const status = queryParamsData.get("status") ?? "";
  const search = queryParamsData.get("search") ?? "";

  const queryParams = [];
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <MainLayout breadCrumb="ADMIN  /  Manufacturer  / Version History">
      <div>
        <div className="search-container d-flex justify-content-between ">
          <div className="d-flex w-100">
            <div
              className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
              onClick={() => navigate("/manufacturer/subscibe-list")}
            >
              <img src={back} alt="back_btn" />
              <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                BACK
              </span>
            </div>
            <div className="w-100 d-flex justify-content-between">
              <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} color={""} alt="0" />
                <input
                  value={search}
                  className="search-input fs_14 fw_400 px-2 text-dark"
                  type="text"
                  placeholder="Search manufacturers here by manufacturer ID, manufacturer name..."
                  onChange={(e) => {
                    navigate(
                      `/manufacturer/subscibe-list/version-list?page=1${
                        e.target.value ? `&search=${e.target.value}` : ""
                      }${queryString}`
                    );
                  }}
                />
              </div>
              <button
                onClick={() =>
                  navigate(`/manufacturer/subscibe-list/version-list`)
                }
                className="py-1 border-0 rounded-2 m-1 mx-2 px-3 fs_14 Medium_Purple"
              >
                Clear Filters
              </button>
            </div>
          </div>
        </div>
        <ManufacturerVersionTable
          search={search}
          status={status}
          page_no={page_no}
        />
      </div>
    </MainLayout>
  );
};

export default ManufacturerVersionList;
